import _debounce from 'lodash/debounce';
import {
	getBreakpoint,
	horizontalResizeEvent,
} from '../../../../design3/asset-build/js/custom/_utils';

export default function venueFinder() {
	const isMobile = () => {
		return getBreakpoint() === 'small' || getBreakpoint() === 'medium';
	};

	const setHeight = ($wrapper, allRows) => {
		// don't include the header height on mobile
		// even when it's display: none the height still comes through
		let headerHeight = isMobile() ? 0 : $wrapper.find('.VenueFinder-table-header').height();

		let divHeights = 0;

		if (allRows) {
			//get the height of all rows and row headers
			$wrapper.find('.VenueFinder-table-section-row').each((idx, ele) => {
				divHeights += $(ele).height();
			});
		} else {
			//get the height of only the rows and headers that are showing
			$wrapper.find('.display, .displayHeader').each((idx, ele) => {
				divHeights += $(ele).height();
			});
		}

		let newHeight = divHeights + headerHeight;
		$wrapper.height(newHeight);
	};

	const scrollToTop = value => {
		//this could be improved. It's a bit of a guess
		// at the nav height
		let extraPadding = isMobile() ? 80 : 220;
		$('html, body').animate(
			{
				scrollTop: value - extraPadding,
			},
			1000
		);
	};

	const init = () => {
		$('.VenueFinder-wrap').each((i, wrapper) => {
			let $wrapper = $(wrapper);

			// Give display class to first eight venues
			// This will set the table height when/if the list is contracted.
			$wrapper
				.find('.VenueFinder-table-section-row')
				.not('.VenueFinder-table-section-row-header')
				.slice(0, 8)
				.each((idx, ele) => {
					$(ele).addClass('display');
					$(ele).siblings('.VenueFinder-table-section-row-header').addClass('displayHeader');
				});

			if (
				$wrapper.find('.VenueFinder-table-section-row').not('.VenueFinder-table-section-row-header')
					.length > 8
			) {
				$wrapper.siblings('.VenueFinder-seeAll').css('display', 'flex');
				setHeight($wrapper);
			} else {
				$wrapper.addClass('expanded');
			}

			$wrapper
				.siblings('.VenueFinder-seeAll')
				.find('.CTA.expand')
				.on('click', e => {
					e.preventDefault();
					setHeight($wrapper, true);
					$wrapper.addClass('expanded');
				});

			$wrapper
				.siblings('.VenueFinder-seeAll')
				.find('.CTA.shrink')
				.on('click', e => {
					e.preventDefault();
					scrollToTop($wrapper.siblings('.VenueFinder-header').offset().top);
					setHeight($wrapper);
					$wrapper.removeClass('expanded');
				});

			$wrapper
				.siblings('.VenueFinder-header')
				.find('.VenueFinder-unitSelect')
				.on('change', function () {
					let newUnit = this.value.toLowerCase();
					let colText = $wrapper.find('[data-' + newUnit + ']');
					colText.text(colText.data(newUnit));

					let valToGrab = newUnit.replace('size', '');

					$wrapper.find('[data-' + valToGrab + ']').each(function () {
						$(this).html($(this).data(valToGrab));
					});
				});

			$(window).on(
				`${horizontalResizeEvent}`,
				_debounce(() => {
					setHeight($wrapper, $wrapper.hasClass('expanded'));
				}, 25)
			);
		});
	};

	init();
}
